var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.config)?_c('slot-simulator',{attrs:{"config":_vm.config,"uuid":this.$route.params.cuuid}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }